import { MapPin, Phone, ArrowRight } from "lucide-react";
import { Link } from "react-router";

const AREAS = [
  "Lincoln Park",
  "Wicker Park",
  "Lakeview",
  "Logan Square",
  "River North",
  "South Loop",
  "Old Town",
  "Gold Coast",
];

export default function ServiceAreas() {
  return (
    <section
      id="service-areas"
      className="max-w-[90%] xl:max-w-6xl mx-auto"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

        {/* Left: copy */}
        <div className="space-y-8">
          <div className="space-y-4">
            <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
              Where We Work
            </div>
            <h2 className="font-black text-gray-900 text-4xl lg:text-5xl tracking-tight leading-tight">
              Our Service Areas
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed max-w-md">
              We proudly cover all major Chicago neighborhoods — from Lincoln Park to Hyde Park. Our team is ready to handle your plumbing needs quickly and reliably.
            </p>
          </div>

          {/* Areas grid */}
          <ul className="grid grid-cols-2 gap-3">
            {AREAS.map((area) => (
              <li key={area}>
                <Link
                  to={`/locations/${area.toLowerCase().replace(/\s+/g, "-")}`}
                  className="flex items-center gap-2.5 group text-gray-700 hover:text-blue-600 transition-colors"
                >
                  <span className="w-7 h-7 bg-blue-50 group-hover:bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors duration-200">
                    <MapPin className="w-3.5 h-3.5 text-blue-600 group-hover:text-white transition-colors duration-200" />
                  </span>
                  <span className="text-[15px] font-semibold">{area}</span>
                </Link>
              </li>
            ))}
          </ul>

          {/* CTAs */}
          <div className="flex flex-wrap gap-3">
            <Link
              to="/locations"
              className="flex items-center gap-2 bg-white border border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-colors text-gray-700 font-semibold px-6 py-3.5 rounded-xl text-sm"
            >
              View All Locations <ArrowRight className="w-4 h-4" />
            </Link>
            <a
              href="tel:(312) 555-0147"
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 transition-colors text-white font-bold px-6 py-3.5 rounded-xl shadow-md shadow-blue-600/25 text-sm"
            >
              <Phone className="w-4 h-4" /> Call In Your Area
            </a>
          </div>
        </div>

        {/* Right: map */}
        <div className="space-y-3">
          <div className="space-y-1">
            <h4 className="font-bold text-gray-900 text-xl">Find Us On Map</h4>
            <p className="text-sm text-gray-400">
              We cover all these neighborhoods — call for fast, same-day service.
            </p>
          </div>
          <div className="relative">
            <div
              aria-hidden="true"
              className="absolute inset-0 rounded-3xl border-2 border-blue-100 translate-x-3 translate-y-3 -z-10"
            />
            <iframe
              src="https://www.google.com/maps/d/embed?mid=1vq6TECACEAEVS6YDqMldpQJvW2Z9zBE&ehbc=2E312F&noprof=1"
              className="w-full h-96 rounded-2xl shadow-xl border-4 border-white"
              loading="lazy"
              title="Chicago Plumbing service area map"
            />
          </div>
        </div>

      </div>
    </section>
  );
}